import { CarteiraRecomendadaProvider } from "projects/core/src/lib/core/provider/CarteiraRecomendadaProvider"


export class CarteiraRecomendadaAlteracaoPageViewModel {
    carteiraRecomendadaProvider = new CarteiraRecomendadaProvider()
    
    async getHistorico(idCarteira): Promise<any> {
        try {
            const retorno: any = await this.carteiraRecomendadaProvider.getHistorico(idCarteira)
            return retorno.data
        } catch(e) {
            return []
        }
    }
}